import ProductFeedCard from './ProductFeedCard';

const ProductFeedsCards = ({ productFeeds, stats, period }) => {
  return productFeeds.map((productFeed) => {
    return <ProductFeedCard key={productFeed.id} productFeed={productFeed} stats={stats} period={period} />;
  });
};

export default ProductFeedsCards;
